export default __webpack_public_path__ + "static/media/rupay.5e200eaf.svg";